import Button from '@/shared/Button/Button';
import useStartFreeTrialButton from './useStartFreeTrialButton.hook';

const teacherProSubscriptionTypeId = 1;

export default function StartFreeTrialButton({
  subscriptionTypeId = teacherProSubscriptionTypeId,
  onFinish = () => {},
  buttonProps = {},
}) {
  const { state, actions } = useStartFreeTrialButton({
    subscriptionTypeId,
    onFinish,
  });

  return (
    <Button
      type="primary"
      onClick={actions.startFreeTrial}
      loading={state.processing}
      disabled={state.processing}
      size="large"
      {...buttonProps}
    >
      Start FREE trial
    </Button>
  );
}
